import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from "@angular/router";
import { ApiConstants } from 'src/app/constants/api-path.constants';
import { RouterConstants } from 'src/app/constants/router.constants';
import { ModelUserInfoDetails } from 'src/app/model/user/user-settings';
import { ApiService } from 'src/app/services/api.service';
import { ServiceLocalStorage } from 'src/app/services/local-storage.service';
import { ServiceSharedData } from 'src/app/services/shared-data.service';
import { environment } from 'src/environments/environment.prod';
import { ConfirmationAlertComponent } from '../confirmation-alert/confirmation-alert.component';
import { Location } from "@angular/common";
import { DomSanitizer } from '@angular/platform-browser';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NotificationService } from '../Utils/notification.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  roleid: any;
  menuItems = [];
  element: any;
  firstNameDisplayOnTop: any;
  _mLogo: any;
  flagImage: any = false;
  username: String;
  employeeId: String;
  categoryName: String;
  rolename: String;
  companyId: number;
  clientCode: any;
  mapType: any;
  _currentUser: any;
  lastLogin: any;
  _mRoute: string;
  _mSubRoute: string;
  _currentUserData: any;
  _mRestrictCovid: any = false;
  _mCheck: any = false;
  _rolePermissions;
  imgData: any;
  userId: any;
  userUrl: any = '';
  notificationFlag: boolean = true;
  count: number;

  constructor(@Inject(DOCUMENT) private document: any,
    private readonly apiService: ApiService,
    private sanitizer: DomSanitizer,
    public router: Router,
    public dialog: MatDialog,
    private location: Location,
    private readonly ngxLoader: NgxUiLoaderService,
    private readonly serviceLocalStorage: ServiceLocalStorage,
    private serviceSharedData: ServiceSharedData,
    private notifyService: NotificationService) {
    // this.apiService.getProfileObs().subscribe((res: any) => {
    //   this.userUrl = res;
    // })
    this.serviceLocalStorage.getFirstNameObs().subscribe((result: any) => {
      this.firstNameDisplayOnTop = result ? result : window.sessionStorage.getItem('firstNameDisplayOnTop') !== null ? window.sessionStorage.getItem('firstNameDisplayOnTop') : '';
    })
  }

  ngOnInit(): void {
    // this.requestPermission();
    // this.listen();
    this.element = document.documentElement;
    // if (this.serviceLocalStorage.hasAuthToken()) {
    this.apiService.doGetRequestWithResponse(ApiConstants.getCurrentUser, success => {
      this.roleid = success.body.role.id;
      this.getRolePermission();
      this.getAllNotification();
      //     this._mLogo = success.body.userInfoDetails.site.location.company;
      //     if (this._mLogo.covidLogo != null) {
      //       this.flagImage = true;
      //     }
      //     this.username = success.body.userInfoDetails.displayName;
      //     this.employeeId = success.body.userInfoDetails.employeeId;
      //     this.categoryName = success.body.category != null ? success.body.category.category.split(" ")[1] : "NA";
      //     this.companyId = success.body.userInfoDetails.site.location.company.companyId;
      //     this.clientCode = success.body.clientCode;
      //     this.mapType = success.body.userInfoDetails.site.location.company.mapType;
      //     this._currentUser = success.body;
      //     this.serviceLocalStorage.setJsonValue('user', success.body);
      //     this.lastLogin = success.body.lastLoginDate;
      //     let userInfoDetail: ModelUserInfoDetails = success.body.userInfoDetails;
      //     this._currentUserData = JSON.stringify(userInfoDetail);
      //     this.serviceSharedData.setData(ServiceSharedData.CURRENT_USER.company, userInfoDetail.site.location.company);
      //     this.serviceLocalStorage.setSiteId(userInfoDetail.site.siteId.toString());
      //     this.rolename = userInfoDetail.role.name.toString();
      //     this.serviceLocalStorage.setJsonValue('roleId', userInfoDetail.role.id.toString());
      //     this.serviceLocalStorage.setJsonValue('roleName', userInfoDetail.role.name);
      //     this.serviceLocalStorage.setLocationId(userInfoDetail.site.location.locationId.toString());
      //     this.serviceLocalStorage.setCompanyId(userInfoDetail.site.location.company.companyId.toString());
      //     this.serviceLocalStorage.setcompanyWeeklyOff(userInfoDetail.site.location.company.weeklyOffDays);
      //     this.serviceLocalStorage.setUserId(success.body.id.toString());
      //     this.serviceLocalStorage.setMapType(userInfoDetail.site.location.company.mapType);
      //     this.apiService.doGetRequestWithResponse(ApiConstants.getDelegatedRoleByUserId + success.body.id, (response) => {
      //       if (response.status === 200) {
      //         this.roleid = response.body.id;
      // this.getRolePermission();
      //       }
      //     }, error1 => {
      //       this.roleid = userInfoDetail.role.id;
      //       this.getRolePermission();
      //     });
    }, error => {
      console.log(error)
    });
    //   this._mRoute = this.serviceLocalStorage.getRouteName();
    //   this._mSubRoute = this.serviceLocalStorage.getSubRouteName();
    //   if (this._mSubRoute == "User") {
    //     if (this.location.path() != "") {
    //       let routePath = this.location.path();
    //       this.updateRouteEnd(routePath);
    //       return;
    //     }
    //   }
    // }
    // this.getProfilePhoto();
  }

  getRolePermission() {
    this.getRolePermissions(this.roleid).then(value => {
      this._rolePermissions = this.serviceLocalStorage.getPermissionObject();
      this._mRestrictCovid = this._rolePermissions.restrictmyrisksecure;
      if (this._mRestrictCovid) {
        this._mCheck = true;
        this.router.navigate(['/' + RouterConstants.layoutContainer + '/' + RouterConstants.dashboard]);
      }
      this.setMenu();
    });
  }

  getRolePermissions(roleId) {
    return new Promise(resolve => {
      this.apiService.doGetRequestWithResponse(ApiConstants.getRolePermissions + roleId, success => {
        if (success.status == 200) {
          console.log("result", success.body)
          this.serviceLocalStorage.setPermissionObject(success.body);
          resolve(null);
        }
      }, error => {
        resolve(error);
      });
    });
  }

  updateRouteEnd(path: string) {
    if (path.includes("/changepassword")) {
      this._mRoute = "Change Password";
      this._mSubRoute = "";
    } else {
      for (const dashboardItem of this.menuItems) {
        if (dashboardItem.items)
          for (const route of dashboardItem.items) {
            if (path.includes(route.route)) {
              this._mRoute = dashboardItem.name;
              this._mSubRoute = route.name;
              return;
            }
          }
      }
    }
  }

  setMenu() {
    this.menuItems = [{
      id: 1,
      label: 'Dashboard',
      icon: 'bx-home-circle',
      link: '/help-desk/dashboard',
      permission: this._rolePermissions.dashboard
    },
    {
      id: 2,
      label: 'Tickets',
      icon: 'bx-file',
      link: '/help-desk/tickets',
      permission: this._rolePermissions.tickets
    }, {
      id: 3,
      label: 'Knowledge Base',
      icon: 'bx-task',
      link: '/help-desk/solutions',
      permission: this._rolePermissions.solutions
    }, {
      id: 4,
      label: 'Reports',
      icon: 'bx-bar-chart-alt-2',
      link: '/help-desk/reports',
      permission: this._rolePermissions.reports
    }, {
      id: 5,
      label: 'Setup',
      icon: 'bx-cog',
      link: '/help-desk/setup',
      permission: this._rolePermissions.setup
    }];
  }
  message: any = null;
  requestPermission() {
    const messaging = getMessaging();
    getToken(messaging, { vapidKey: environment.firebase.vapidKey }).then((currentToken) => {
      if (currentToken) {
        console.log("Hurraaa!!! we got the token.....");
        console.log(currentToken);
        localStorage.setItem("fcmToken", currentToken);
        this.WebFcmTokenToServer(currentToken);
      } else {
        console.log('No registration token available. Request permission to generate one.');
      }
    }).catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
  }
  totalElement: any[] = [];
  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      this.message = payload;
      this.totalElement.push(this.message);
    });
  }

  WebFcmTokenToServer(webFcmToken) {
    this.apiService.doGetRequestWithResponse(ApiConstants.captureWebFcmToken + webFcmToken, success => {
      if (success.status == 200) {
        console.log(success.body.message);
      }
    }, error => {
      console.log(error)
    });
  }
  notificationData: any[] = [];
  allNotificationData: any[] = [];
  getNotification() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getUserWebNotification + this.serviceLocalStorage.getUserId(), success => {
      if (success.status == 200) {
        this.notificationData = success.body;
      } else {
        this.notifyService.showInfo("you dont have any notification",null);
        this.notificationFlag = false;
      }
    }, error => {
      console.log(error);
    });
  }

  getAllNotification() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getAllUserWebNotifications + this.serviceLocalStorage.getUserId(), success => {
      if (success.status == 200) {
        this.allNotificationData = success.body;
        this.count = this.allNotificationData.length > 0 ? this.allNotificationData.length : 0;
        this.notificationData = this.allNotificationData;
      } else {
        this.notificationData = [];
        this.notificationFlag = false;
      }
    }, error => {
      console.log(error);
    });
  }

  onClick(item) { }

  myProfile() {
    this.router.navigate(['/' + RouterConstants.layoutContainer + '/' + RouterConstants.userProfile.baseUrl + '/' + RouterConstants.userProfile.myProfile]);
  }

  changePassword() {
    this.router.navigate(['/' + RouterConstants.layoutContainer + '/' + RouterConstants.userProfile.baseUrl + '/' + RouterConstants.userProfile.changePassword]);
  }

  logout(): void {
    // var ssoLoggedIn = localStorage.getItem("fromSSO");
    var clientCode = localStorage.getItem("clientCode");
    this.flagImage = false;
    // if (ssoLoggedIn != null && ssoLoggedIn === 'true') {
    //   this.serviceLocalStorage.deleteAll();
    //   var ssoLogOutUrl = environment.ssoLogOut;
    //   window.location.href = ssoLogOutUrl.replace(new RegExp('{clientCode}', 'g'), clientCode);
    // } else {
    const dialogRef = this.dialog.open(ConfirmationAlertComponent, {
      width: '324px',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.serviceLocalStorage.deleteAll();
        this.router.navigate(['/' + RouterConstants.auth]);
      }
    });
    // }
  }

  transform() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.userUrl);
  }

  getProfilePhoto() {
    this.userId = this.serviceLocalStorage.getUserId();
    if (this.userId) {
      this.apiService.doGetRequestWithResponse(ApiConstants.getprofilePhoto + this.userId, success => {
        if (success.status === 200) {
          this.imgData = success.body;
          if (this.imgData) {
            this.userUrl = this.imgData.url;
          } else {
            this.userUrl = '';
          }
        } else {
          this.imgData = '';
          this.userUrl = '';
        }
      }, error => {
        console.log(error)
      });
    }
  }

  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  clearNotification() {
    let ids = [];
    this.notificationData.forEach(element => {
      ids.push(element.notificationId);
    })
    this.apiService.doGetRequestWithResponse(ApiConstants.markUserNotificationsAsRead + "?notificationIds=" + ids,success =>{
      if(success.status == 200) {
       this.count = this.count - ids.length >= 0 ? this.count - ids.length : 0;
       this.getAllNotification();
      }
    },error => {
      console.log("error");
    })
  }
}
